/** Cross-UI bridge so list chrome can open Jet (and optionally ask). */

export const JET_OPEN_EVENT = 'demandjet:jet-open';

/**
 * Open the Jet assistant. Pass `prompt` to ask immediately after open.
 * @param {{ prompt?: string }} [options]
 */
export function openJetAssistant({ prompt } = {}) {
  if (typeof window === 'undefined') return;
  const text = String(prompt || '').trim();
  window.dispatchEvent(
    new CustomEvent(JET_OPEN_EVENT, {
      detail: { prompt: text || null },
    })
  );
}

/**
 * Contextual footer chips for Option D smart actions.
 * Labels stay short; prompts are what Jet actually receives.
 */
export function listFooterJetActions(pathname = '') {
  const path = String(pathname || '');
  if (path.includes('/debtors')) {
    return [
      { label: 'Who owes the most?', prompt: 'Who owes the most among my debtors?' },
      { label: 'List past-due debtors', prompt: 'List my past-due debtors and what to do next.' },
    ];
  }
  if (path.includes('/payments')) {
    return [
      { label: 'Summarize recent payments', prompt: 'Summarize my recent payments.' },
      { label: 'Find unmatched payments', prompt: 'Help me find unmatched or incomplete payments.' },
    ];
  }
  if (path.includes('/messages')) {
    return [
      { label: 'Threads needing a reply', prompt: 'Which message threads need a reply?' },
      { label: 'Summarize unread', prompt: 'Summarize my unread message threads.' },
    ];
  }
  if (path.includes('/evidence')) {
    return [
      { label: 'What’s missing evidence?', prompt: 'What evidence might be missing from my locker?' },
      { label: 'Group files by debtor', prompt: 'How should I group evidence files by debtor?' },
    ];
  }
  if (path.includes('/demands/new') || path.includes('/intake')) {
    return [
      { label: 'Help me fill this demand', prompt: 'Help me fill out this new demand.' },
      { label: 'What evidence do I need?', prompt: 'What evidence should I attach for this demand?' },
    ];
  }
  if (path.includes('/home')) {
    return [
      { label: 'What needs attention?', prompt: 'What needs my attention today?' },
      { label: 'Summarize overdue', prompt: 'Summarize my overdue demands.' },
    ];
  }
  // Demands / default record lists and other pages
  return [
    { label: 'Summarize overdue', prompt: 'Summarize my overdue demands.' },
    { label: 'Find unpaid over $5k', prompt: 'Find unpaid demands over $5,000.' },
  ];
}
